<template>
  <div class="news-all">
    <div class="title"><span class="time">05.31<br>2016</span><span class="tiel">美菜启动“66季”，新鲜低价到不可思议！</span></div>
	<div class="mat-content">
		<p align="center"><img src="https://img-oss.yunshanmeicai.com/cfile/1d2bbc9f95d7a1251e06f5291053d1f6.jpg" width="640"></p>
		<div class="tet-js">近两年，国家大力提倡涉农电子商务的发展，生鲜电商成为资本最大的一块掘金地。在这场生鲜B2B电商狙击战中，美菜吹响冲锋号一举成为行业首屈一指的B2B电商平台。2016年6月6日，在美菜网成立两周年之际，作为国内最大的农产品移动电商平台，开展美菜“66季”周年庆典活动，热推“新鲜低价，狂欢购”。活动时间从6月1日-6月30日，整整持续一个月！此次活动面向全国近千万中小餐饮商家，整合国内将众多优秀供应商资源、数百家农村合作社及产地直供，从生鲜蔬果、肉禽蛋类到米面粮油、调料酒水，以全品类、超低价，结合各类线上优惠及线下推广活动，倾力打造前所未有的周年庆盛典。
		
		</div>
	</div>
	<div class="mat-content">
		<div class="title-bold"><span></span>新鲜到极致：源头直采，冷链无忧</div>
		<div class="tet-js">美菜对于前期合作的种植基地是极为严格的，要求是绿色、生态，并且对种植技术和种苗的引进都有相应的要求。其次，美菜有自己完善的冷链物流体系，从基地采收、预冷降温、装箱配送、质检验货、挑选、称重、包装，订单分拣、核货，最后装车配送送达餐厅，这个过程用不到8个小时，最大限度的保留了产品的新鲜度。美菜“66季”活动期间，更是加大了物流的投放力度，保障在大量订单下也能准时送到餐厅的餐桌上。
			<p align="center" style="padding: 40px 0 10px;"><img src="https://img-oss.yunshanmeicai.com/cfile/3e572c6bf6b09edd590cfc1b9f7b85d0.jpg"></p>
</div>
	</div>
	<div class="mat-content">
		<div class="title-bold"><span></span>低价到不可思议：将中间环节一刀切！</div>
		<div class="tet-js">有资料显示，中国农产品从田头到餐厅，要经过收购、运输、仓储、批发、配送、零售等6个环节，流通成本占到40%（粮食）~60%（果蔬）。而美菜颠覆传统，巧妙的将农户与餐厅以互联网电商的方式直接联系起来，自建物流冷链体系成为二者的桥梁，于是砍掉了所有的中间商，节省了近90％的利润。因此在美菜“66季”活动期间，美菜将真正让利给千万中小餐饮商家，价格低到不可思议，绝对的物美价廉，还有多重优惠！
		</div>
	</div>
	<div class="mat-content">
		<div class="title-bold"><span></span>抄底价来袭：给你便宜还给你优惠！</div>
		<div class="tet-js">美菜推出美菜“66季”周年狂欢庆活动，不仅让利给各大餐厅老板，并且在整整一个月当中投入超千万级的促销费用，回馈商户。转盘抽奖、砸金蛋等重磅活动即将上线，iPhone SE手机、乐视TV、海量优惠券天天送！<br/><br/>

&nbsp;&nbsp;<em style="font-size: 10px;">●</em> 天天低价：活动期间，每天会供应几款超级低价的限量商品。若购买的指定商品高于市场价格，购买客户可获得双倍价差赔付。<br/>
&nbsp;&nbsp;<em style="font-size: 10px;">●</em> 超级免单王：你消费，我买单，最高免3000元！<br/>
&nbsp;&nbsp;<em style="font-size: 10px;">●</em> 砸金蛋送乐视：每日一砸蛋，天天送乐视！<br/>
&nbsp;&nbsp;<em style="font-size: 10px;">●</em> 连续下单送电脑：下单次数越多，抽奖得奖品越多！<br/>
&nbsp;&nbsp;<em style="font-size: 10px;">●</em> 一键转发100％得优惠：分享转发得优惠券，无门槛！<br/>
&nbsp;&nbsp;<em style="font-size: 10px;">●</em> 刮卡集字送iphone：集齐“美菜生日快乐”送手机！<br/>
美菜希望通过“新鲜低价”，让更多的客户得到更好的体验。CEO刘传军认为：近两年整个互联网在向农村、农业下沉，包括国家相关政策的扶持。美菜不仅要降低成本，更要做好客户服务，保证菜品的新鲜。相信在此次美菜“66季”周年狂欢庆活动中，大家会获得不少红利，让我们拭目以待吧！</div>
	</div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
